import React from 'react';
import styled from 'styled-components';

import Btn from '../../buttons/Btn';
import { toTitleCase } from '../helpers/helpers';

const Container = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: #354354;
`;

const Text = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: #354354;
`;

const Link = styled.a`
  color: #4a90e2;
  text-decoration: none;
  font-size: 18px;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const StyledBtn = styled(Btn)`
  margin-top: 20px;
  width: 100%;
  max-width: 230px;
`;

type InfoConfirmationProps = {
  pointDate: string;
  userInfo: {
    nom: string;
    prenom: string;
    phone: string;
    email: string;
  };
  onButtonClick: (pointId: string) => void;
  pointId: string;
  center: any;
};

const InfoConfirmation = ({
  pointDate,
  userInfo,
  onButtonClick,
  pointId,
  center,
}: InfoConfirmationProps) => {
  const { nom, prenom, phone, email } = userInfo;

  return (
    <Container>
      <Title>Mon stage</Title>
      <Text>{pointDate}</Text>
      <Text>{toTitleCase(center.name)}</Text>
      <Text>
        {center.address1}, {toTitleCase(center.city)}
      </Text>
      <Title>Mes coordonnées</Title>
      <Text>
        {prenom} {nom}
      </Text>
      <Text>{phone}</Text>
      <Link href="mailto:{email}" target="_blank" rel="noopener noreferrer">
        {email}
      </Link>

      <StyledBtn
        type="submit"
        text="Je réserve mon stage"
        block
        isLoading={false}
        onClick={() => onButtonClick(pointId)}
      />
    </Container>
  );
};

export { InfoConfirmation };
